import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {StorageManagerGatewayCapacitor} from './adapters/real/app-services/storage-manager-gateway-capacitor';
import {catchError, switchMap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {NavController} from '@ionic/angular';
import {UserModel} from './core-logic/models/user/user-model';
import {SocketIoService} from './common/services/socket-io.service';

@Injectable({providedIn: 'root'})
export class HttpRequestsInterceptor implements HttpInterceptor {
  private currentUser: UserModel;
  constructor(private navCtrl: NavController, private socketIoService: SocketIoService,
              private storageManagerGatewayCapacitor: StorageManagerGatewayCapacitor) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request: HttpRequest<any>;
    const headers = req.headers.set('X-API-Version', 'v2');
    if (req.url.includes('/api/create-phone-number')
      || req.url.includes('/api/confirm-phone-number')
      || req.url.includes('/api/create-password')
      || req.url.includes('/api/login')) {
      request = req.clone({headers: headers.delete('Authorization')});
      return next.handle(request);
    } else {
      return this.storageManagerGatewayCapacitor.getCurrentUser().pipe(switchMap( currentUser => {
        this.currentUser = currentUser as UserModel;
        request = req.clone({headers: headers.set('Authorization', 'Bearer ' + this.currentUser?.token)});
        return next.handle(request).pipe(catchError( error => {
          if (error.status === 498) {
            return this.storageManagerGatewayCapacitor.clear().pipe(switchMap(() => {
              this.socketIoService.close();
              this.navCtrl.navigateRoot('/entrance');
              return next.handle(null);
            }));
          } else {
            return throwError(error);
          }
        }));
      }));
    }
  }
}
